import { render, staticRenderFns } from "./ServiceProvider.vue?vue&type=template&id=53cd9beb&scoped=true"
import script from "./ServiceProvider.vue?vue&type=script&lang=js"
export * from "./ServiceProvider.vue?vue&type=script&lang=js"
import style0 from "./ServiceProvider.vue?vue&type=style&index=0&id=53cd9beb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53cd9beb",
  null
  
)

export default component.exports